import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import { SETTING_CONFIG } from './config.'
import Swal from 'sweetalert2'
import RequireSelect from '../../component/RequireSelect'
import dayjs from 'dayjs'
import RequireField from '../../component/RequireField'

export default function ViewMaterial() {
  
    const navigate = useNavigate();

    const { id } = useParams()
    const [detail, setDetail] = useState()
    const [dataUnit, setDataUnit] = useState([])
    const [description, setDescription] = useState()
    const [materialName, setMaterialName] = useState()
    const [materialNameError, setMaterialNameError] = useState(false)
    const [unitNo, setUnitNo] = useState()
    const [unitNoError, setUnitNoError] = useState(false)
    const [requireSize, setRequireSize] = useState(true)
    const [status, setStatus] = useState('Y')
   

    const getUnit = async () => {
        const res = await api.get(`dbms/units`)
        const data = await res.data.result
        if (res.data.status === true) {
            setDataUnit(data)
        }
    }
    const getItemMasterInfo = async () => {

        const url = 'dbms/materials' + `/${id}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setDetail(data.result)
            setMaterialName(data.result.ItemName)
            setDescription(data.result.Description)
            setRequireSize(data.result.CatalogNo.RequireSize)
            setStatus(data.result.Status)
            setUnitNo(data.result.UnitNo.UnitNo)
        }
    }
    useEffect(() => {
        getUnit()
        if (id) {
            getItemMasterInfo()
        }
    }, [])
    const handleSubmit = async () => {
      
        const body = {
            MaterialName: materialName,
            Description: description || null,
            UnitNo: unitNo,
            RequireSize: requireSize,
            Status: status
        }
        const itemAdd = async () => {


            if (id) {
                // const url = SETTING_CONFIG.requests.getItemMasters.url + `/${body?.ItemNo}`;
                const url = 'dbms/materials' + `/${id}`;
                const res = await api.put(url, body)
                const data = res.data
                if (data.status === true) {
                    Swal.fire(
                        'ทำรายการสำเร็จ',
                        '',
                        'success'
                    )
                    getItemMasterInfo()
                }else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }
            } else {

                const res = await api.post('dbms/materials', body)
                const data = res.data
                if (data.status === true) {
                    navigate('/setting/materials/'+ data.result.ItemNo)

                    Swal.fire(
                        'ทำรายการสำเร็จ',
                        '',
                        'success'
                    )
                    getItemMasterInfo()
                }else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }

            }
        }
        if (!materialName) {
            setMaterialNameError(true)
        }
        if (!unitNo) {
            setUnitNoError(true)
        }
        
        if (materialName && unitNo) {
            itemAdd()
        }
           
    }
  return (
    <div style={{ padding: '10px 30px' }}>
    <Page>
        <div class="container-fluid">

            <div class=" d-flex row justify-content-between align-items-baseline">
                <div class="col-lg-12 col-md-12 text-left ">
                    <label class="title-content mb-4">
                        {id ? 'รายละเอียดวัสดุ' : 'เพิ่มรายละเอียดวัสดุ'}
                    </label>


                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-12 " style={{ marginBottom: '10px' }}>
                    <label class="labelInput">ชื่อวัสดุ</label>
                    <RequireField value={materialName} onChange={setMaterialName} type={'text'} error={materialNameError} setError={setMaterialNameError} textError={'กรุณากรอกชื่อ'} />
                </div>
              
                <div class="col-lg-4 col-sm-12 " style={{ marginBottom: '10px' }}>
                    <label class="labelInput">หน่วย</label>
                    <RequireSelect value={unitNo} onChange={setUnitNo} menu={dataUnit?.map((x, i) => (
                        <MenuItem key={i} value={x?.UnitNo}>{x?.UnitName}</MenuItem>
                    ))} disabled={false} error={unitNoError} setError={setUnitNoError} textError={'กรุณาเลือกหน่วย'} />
                </div >
               
                <div class="col-lg-8 col-sm-12">
                    <label class="labelInput">คำอธิบาย</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px', borderRadius:'25px' }}>
                        <TextField disabled={false} value={description} onChange={e => setDescription(e.target.value)} variant="standard" fullWidth multiline rows={3}
                            InputProps={{
                                disableUnderline: true,
                            }}
                        />
                    </Box>
                </div>
                {id &&
                    <div class="row" >
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/YYYY')} )</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField disabled value={detail?.CreateId} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/YYYY')} )</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField disabled value={detail?.ModifiedId} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                    </div >}
                <div class="col-md-12 mt-1  text-left ">
                    <div class="d-flex align-items-center" style={{ flexWrap: 'wrap' }}>
                        <div style={{ borderRight: '2px solid gray' }}>
                            <RadioGroup row
                                value={status} onChange={e => setStatus(e.target.value)}
                            >
                                <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                                <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                            </RadioGroup>
                        </div>

                        <div style={{ marginLeft: '15px' }}>
                            <RadioGroup row
                                value={requireSize} onChange={e => setRequireSize(e.target.value)}
                            >
                                <FormControlLabel  value={true} control={<Radio />} label="ระบุขนาด" />
                                <FormControlLabel  value={false} control={<Radio />} label="ไม่ระบุขนาด" />
                            </RadioGroup>
                        </div>

                    </div>

                </div>


            </div >


            <hr class="chr" />
            <div class="row ">

                <div class="col-12 text-left">
                    <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                    <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => handleSubmit()}>{id ? 'เเก้ไข' : 'บันทึก'}</Button>

                </div >
            </div >
        </div >



    </Page >
</div >
  )
}
